<template>
    <div>
        <!-- 导航栏 -->
        <Header :active="3" @show-contact="showContact" :title="'动态详情'"></Header>
        <!-- 新闻详情 -->
        <div class="detail-n">
            <h1>{{ newsDetail.title }}</h1>
            <p class="date-n">{{ newsDetail.publishDate.split(' ')[0] }}&nbsp;发布</p>
        </div>
        <div class="contents-n" v-html="newsDetail.details"></div>
        <!-- 结尾 -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>
<script>
import { newsDetail } from '../api/news'
import { uploadeImage } from '../api/images'
import { baseUrl } from '../api/images';
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
import Contact from '../components/Contact.vue'
import Email from '../components/Email.vue'
export default {
    data(){
        return {
            newsDetail: [],
            baseUrl: uploadeImage,
            isFixed: false,
            logo: baseUrl + 'logo_blue.png',
            menu: baseUrl + 'menu_blue.png',
            isShow: false,
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    mounted() {
        this.$nextTick(() => {
            this.adjustImages();
        });
    },
    created() {
        const id = this.$route.params.id;
        //创建组件的时候调用查询所有用户的方法
        this.getNewsDetail(id)
    },
    methods: {
        goToNewsDetail(id) {
            this.$router.push({ name: 'NewsDetail', params: { id } });
        },
        async getNewsDetail(id) {
            const { data } = await newsDetail(id)
            this.newsDetail = data;
            console.log(this.newsDetail)
        },
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        },
        adjustImages() {
            const images = this.$el.querySelectorAll('img');
            images.forEach(img => {
                img.style.width = '20%';
                img.style.height = 'auto';
                img.style.objectFit = 'contain'; // 保持图片比例，确保图片完整显示在容器内
            });
        }
    }
}
</script>
<style scoped>

img {
    width: 100%;
}
.nav-links a {
    color: rgba(45, 118, 252, 1);
    font-weight: 500;
}
.detail-n {
    width: 11.51rem;
    margin: 1.52rem auto 0;
}
.detail-n h1 {
    font-size: 0.28rem;
}
.detail-n .date-n {
    color: #7f7f7f;
    font-size: 0.14rem;
    font-weight: 400;
    margin-top: 0.23rem;
}

.detail-n .contents-n {
    font-size: 20px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    text-align: justify;
}
.contents-n {
    width: 11.51rem;
    margin: 0.46rem auto 1.21rem;
}

.ql-align-center img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 裁剪图片以覆盖整个容器 */
}

.header .hh-menus .on {
    border-bottom: thick solid rgba(44, 117, 252, 1);
}
@media (max-width: 1200px) {

    .detail-n {
        width: 3.45rem;
        margin: 0.88rem auto 0;
    }
    .detail-n h1 {
        font-size: 0.2rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: left;
        color: #333333;
        line-height: 0.3rem;
        letter-spacing: 0.004rem;
    }
    .contents-n {
        width: 3.45rem;
        margin: 0 auto;
    }

    .detail-n .date-n {
        font-weight: 400;
        margin:0.21rem 0 0.45rem;
        font-size: 0.12rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #7f7f7f;
        line-height: 0.16rem;
    }

    .contents-n {
       margin-bottom: 1.17rem;
    }

    
}
</style>